

















































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<MissionIcon>({})
export default class MissionIcon extends Vue {
  @Prop() size: number;
}
